import React from 'react';
import ProfileSettings from '../components/ProfileSettingsComponent/ProfileSettings';

const ProfileSettingsPage = () => {
  return (
    <div>
      <ProfileSettings />
    </div>
  );
};

export default ProfileSettingsPage;
